import { getApiUrlTemplateFunc } from '../../../helpers/getApiUrlTemplateFunc'
import API from '../../../services/api'
import { abbreviationsAPIMessages } from './configs'
import { PRIVATE_BASE_URL } from '../../../configs'
import { KnowledgeFile } from 'tabs/nlp/components/knowledgeBase/types/knowledge-types'
import { alertError, alertSuccess } from '../../../api'

const template = getApiUrlTemplateFunc('')

const queryString = '?type=FILE'

const deleteKnowledgeFile = async (id: string): Promise<any> => {
  return API.delete(template(`knowledge/${id}${queryString}`)).then(response => {
    alertSuccess(abbreviationsAPIMessages.deleted)
    return response
  })
}

const updateKnowledgeFile = async (body: any): Promise<any> => {
  return API.put(template(`knowledge/${queryString}`), body)
}

const downloadKnowledgeFile = async (id: string, body: any): Promise<Blob> => {
  try {
    return await API.binaryPost(template(`knowledge-file/${id}/download`), body)
  } catch (error) {
    alertError('Error during downloading')
  }
}

const trainFiles = async (): Promise<any> => {
  return API.post(template(`knowledge/train/${queryString}`), [])
}

export const getColaKnowledgeFiles = (): Promise<KnowledgeFile[]> => {
  const queryString = '?type=FILE'
  return API.get(`${PRIVATE_BASE_URL}/knowledge${queryString}`).then(res => res.sources)
}

export const knowledgeFileService = {
  deleteKnowledgeFile,
  updateKnowledgeFile,
  downloadKnowledgeFile,
  trainFiles,
}
